/* globals STATIC_URL, GOOGLE_MAP_API_KEY, FORMAZIONE_URL, BCE_ENV */

export default {
  static: filename => `${STATIC_URL}${filename}`,
  googleKey: GOOGLE_MAP_API_KEY,
  // This must be bumped whenever the output of /api/v1/config changes
  cacheVersion: 4,
  sentryDSN: "https://bec5b8d350044b2a937a452b0cb4cdf5@sentry.nephila.it/145",
  profile_user: `https://${BCE_ENV}www.hubscuola.it/profilo`,
  formazione_url: "https://formazione.deascuola.it/offerta-formativa/",
  myevents_url: "/",
  purchaseInfo_url: "https://s3a.deascuola.it/05_DSCUOLA_FORMAZIONE_Condizioni_vendita.pdf",
  api: {
    base: FORMAZIONE_URL || "https://api.formazione.deascuola.it",
    fetchCart: "/api/v1/orders/cart/",
    fetchOrder: "/api/v1/orders/current/",
    orderBase: "/api/v1/orders/",
    orderBundleLegs: "/set-bundle-legs/",
    registrationBase: "/api/v1/registrations/",
    setFiscalCode: "/api/v1/user/fc/",
    states: {
      new: "new",
      data_confirmation: "data-confirmation",
      completed: "completed",
      payment_start: "payment-start",
      waiting_list: "waiting-list",
      pre_registration: "pre-registration",
    },
    tokenName: "sessionId",
    csrfToken: "csrftoken",
  },
  states: {
    New: "new",
    LegSelection: "select_legs",
    Laboratories: "data_confirmation",
    LabsList: ["completed", "payment_start"],
    Tickets: "active",
    pending: ["waiting_list", "pre_registration"],
    waiting_list: "waiting_list",
    pre_registration: "pre_registration",
    on_hold: "payment_on_hold",
    Confirmed: ["active", "waiting_list", "pre_registration", "payment_on_hold"],
    FiscalCodeConfirmation: ["new", "data_confirmation"],
    StartOrEndedRegistration: ["payment_start", "data_confirmation", "completed", "select_legs"],
    Cancelled: "cancelled",
  },
  gtm: {
    affiliation: "DeA Scuola Formazione",
    brand: "DeA Scuola Formazione",
    currencyCode: "EUR",
  },
};
